<div
  class="common-sidebar"
  [ngClass]="sidebarCollapse ? 'sidebar-collapse' : ''"
>
  <ul>
    <li
      class="nav-item"
      *ngFor="let menuItem of commonMenuItems; let i = index"
      (click)="navigateToRouter(menuItem.slug)"
      (mouseenter)="hoveredIndex = i"
      (mouseleave)="hoveredIndex = null"
      [ngClass]="{
        active: activeRoute === menuItem.activeSlug,
        'justify-center': sidebarCollapse,
      }"
    >
      <span
        [pTooltip]="sidebarCollapse ? (menuItem.label | translate) : ''"
        tooltipPosition="right"
      >
        <app-svg-icon
          [icon]="menuItem.icon"
          padding="10px"
          [color]="
            activeRoute === menuItem.activeSlug || hoveredIndex === i
              ? '#E5B611'
              : '#848484'
          "
        ></app-svg-icon>
      </span>
      <span *ngIf="!sidebarCollapse">{{ menuItem.label | translate }}</span>
    </li>
  </ul>

  <div class="btn-arrow-expand" (click)="checkSidebarActive()">
    <span *ngIf="!sidebarCollapse"
      ><img src="https://cdn.catexpert.ab-inbev.com/assets/images/icon-arrow-collapse.svg"
    /></span>
    <span *ngIf="sidebarCollapse"
      ><img src="https://cdn.catexpert.ab-inbev.com/assets/images/icon-arrow-collapse.svg"
    /></span>
  </div>
</div>
